export default {
  "config": {
    "trial": "tones-3",
    "id": "baseline-char",
    "type": "table",
    "title": "Demographic and Clinical Characteristics of the Safety Population at Baseline<sup>23</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>"
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-3",
    "id": "baseline-char",
    "data-type": "table",
    "title": "Demographic and Clinical Characteristics of the Safety Population at Baseline<sup>23</sup>",
    "num-header-rows": 2,
    "num-columns": 6,
    "col-classes": [
      "col-1",
      "pbo",
      "sol",
      "sol",
      "sol",
      "sol"
    ],
    "row-mergeoption": [
      1,
      2,
      5,
      13,
      22
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 2,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Solriamfetol</b></center>",
          "cols": 4,
          "class": "sol"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "<b>Variable</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Placebo<br><no-break>(n = 119)</no-break></b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>37.5 mg<br><no-break>(n = 58)<no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>75 mg<br><no-break>(n = 62)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>150 mg<br><no-break>(n = 117)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>300 mg<br><no-break>(n  = 118)</no-break></b>",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "Age, yr, <no-break>mean (SD)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "54.1 (11.4)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "57.1 (10.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "54.4 (11.5)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "52.7 (10.6)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "53.2 (10.6)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "Sex, male, <no-break>n (%)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "77 (64.7)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "39 (67.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "35 (56.5)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "72 (61.5)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "74 (62.7)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Race, <no-break>n (%)</no-break>",
          "cols": 6,
          "class": "col-1",
          "parentRow": true,
          "parent": 4
        }
      ],
      "row-5": [
        {
          "indent": 1,
          "parent": 4,
          "content": "White",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "87 (73.1)",
          "parent": 4,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "45 (77.6)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "46 (74.2)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "93 (79.5)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "90 (76.3)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-6": [
        {
          "indent": 1,
          "parent": 4,
          "content": "Black/African-American",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "26 (21.8)",
          "parent": 4,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "10 (17.2)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "14 (22.6)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "18 (15.4)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "21 (17.8)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-7": [
        {
          "indent": 1,
          "parent": 4,
          "content": "Asian",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "4 (3.4)",
          "parent": 4,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "3 (5.2)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (1.6)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (2.6)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "6 (5.1)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-8": [
        {
          "indent": 1,
          "parent": 4,
          "content": "Other",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "2 (1.6)",
          "parent": 4,
          "cols": 1,
          "class": "pbo"
        },
        {
          "content": 0,
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (1.6)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (2.6)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (0.8)",
          "parent": 4,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-9": [
        {
          "indent": 0,
          "content": "BMI, kg/m<sup>2</sup>, <no-break>mean (SD)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "33.1 (5.2)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "34.1 (5.3)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "33.4 (5.7)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "33.3 (4.8)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "32.9 (5.6)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-10": [
        {
          "indent": 0,
          "content": "MWT sleep latency, min, <no-break>mean (SD)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "12.4 (7.2)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "13.6 (8.1)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "13.1 (7.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "12.5 (7.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "12.0 (7.3)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-11": [
        {
          "indent": 0,
          "content": "ESS score, <no-break>mean (SD)</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "15.6 (3.3)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "15.1 (3.5)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "14.8 (3.5)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "15.1 (3.4)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "15.2 (3.1)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-12": [
        {
          "indent": 0,
          "content": "CGI-S, <no-break>n (%)</no-break>",
          "cols": 6,
          "class": "col-1",
          "parentRow": true,
          "parent": 12
        }
      ],
      "row-13": [
        {
          "indent": 1,
          "parent": 12,
          "content": "1 = Normal, not at <no-break>all ill</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-14": [
        {
          "indent": 1,
          "parent": 12,
          "content": "2 = <no-break>Borderline ill</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "3 (2.5)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1.7)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (1.6)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "2 (1.7)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (0.8)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-15": [
        {
          "indent": 1,
          "parent": 12,
          "content": "3 = <no-break>Mildly ill</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "8 (6.7)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "5 (8.6)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "4 (6.5)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "7 (6.0)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "10 (8.5)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-16": [
        {
          "indent": 1,
          "parent": 12,
          "content": "4 = <no-break>Moderately ill</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "48 (40.3)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "28 (48.3)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "31 (50.0)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "53 (45.3)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "44 (37.3)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-17": [
        {
          "indent": 1,
          "parent": 12,
          "content": "5 = <no-break>Markedly ill</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "39 (32.8)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "14 (24.1)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "15 (24.2)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "41 (35.0)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "44 (37.3)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-18": [
        {
          "indent": 1,
          "parent": 12,
          "content": "6 = <no-break>Severely ill</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "15 (12.6)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "9 (15.5)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "7 (11.3)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "14 (12.0)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "17 (14.4)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-19": [
        {
          "indent": 1,
          "parent": 12,
          "content": "7 = Among the most <no-break>extremely ill</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "4 (3.4)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (1.7)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "3 (4.8)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "2 (1.7)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-20": [
        {
          "indent": 1,
          "parent": 12,
          "content": "Missing",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "2 (1.7)",
          "parent": 12,
          "cols": 1,
          "class": "pbo"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (1.6)",
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "parent": 12,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-21": [
        {
          "indent": 0,
          "content": "Primary OSA therapy adherence, <no-break>n (%)</no-break>",
          "cols": 6,
          "class": "col-1",
          "parentRow": true,
          "parent": 21
        }
      ],
      "row-22": [
        {
          "indent": 1,
          "parent": 21,
          "content": "Adherent",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "83 (69.7)",
          "parent": 21,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "40 (69.0)",
          "parent": 21,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "45 (72.6)",
          "parent": 21,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "80 (68.4)",
          "parent": 21,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "86 (72.9)",
          "parent": 21,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-23": [
        {
          "indent": 1,
          "parent": 21,
          "content": "Nonadherent",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "36 (30.3)",
          "parent": 21,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "18 (31.0)",
          "parent": 21,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "17 (27.4)",
          "parent": 21,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "37 (31.6)",
          "parent": 21,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "32 (27.1)",
          "parent": 21,
          "cols": 1,
          "class": "sol"
        }
      ]
    }
  }
};